import { useState } from "react";
import { signOut } from "@/lib/auth";
import { VERSION_DISPLAY } from "@/lib/version";
import type { OrgUserRole } from "@/types/firestore";
import { PlatformPortalNavigationView } from "@/components/platform/PlatformPortalNavigationView";
import { platformNavSections, platformRoleLabels } from "@/lib/platformNavigation";

interface PlatformPortalNavigationProps {
  role: OrgUserRole;
  userName?: string;
  userEmail?: string;
}

export function PlatformPortalNavigation({ role, userName, userEmail }: PlatformPortalNavigationProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <PlatformPortalNavigationView
      roleLabel={platformRoleLabels[role] || "Platform Administrator"}
      userName={userName}
      userEmail={userEmail}
      versionLabel={VERSION_DISPLAY}
      sections={platformNavSections()}
      mobileOpen={mobileOpen}
      onMobileToggle={() => setMobileOpen((open) => !open)}
      onSignOut={() => signOut()}
    />
  );
}
